import {throwError as observableThrowError, Observable, from, BehaviorSubject} from 'rxjs';
import {switchMap, catchError, map, tap, filter, take} from 'rxjs/operators';
import {
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpEvent,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';

import {StorageService} from '../storage/storage.service';
import {ConfigService} from '../config/config.service';
import {Injectable, Injector} from '@angular/core';
import {TokenService} from '../token/token.service';
import {AuthenticationService} from '../authentication/authentication.service';
import {ShardHandlerService} from '../sharding/shard-handler.service';


@Injectable()

export class ApiInterceptor implements HttpInterceptor {

    private error: any;
    tokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(private tokens: TokenService, private config: ConfigService, public inj: Injector, private shardHandler: ShardHandlerService) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return from(this.tokens.get()).pipe(switchMap(tokens => {
            let newReq = request.clone();

            if (this.isFirstParty(request.url)) {
                newReq = request.clone({
                    headers: this.headers(request, tokens)
                })
            }

            return next.handle(newReq).pipe(tap((event: HttpEvent<any>) => {
                    return event;
                }),
                catchError((error: HttpErrorResponse) => {
                    // Check what kind of shit we get returned
                    if (error instanceof HttpErrorResponse) {
                        switch (error.status) {
                            case 403:
                            case 401:
                                this.error = error;

                                // Invalid token, just pass the error back
                                if (error.url.indexOf('v1/oauth/token') > 0) {
                                    return observableThrowError(error);
                                }
                                // Try to refresh
                                return this.refreshToken(newReq, next)
                            //break;
                        }
                    }
                    return observableThrowError(error);
                })
            )
        }))
    }


    private isFirstParty(url: string) {
        let api = this.config.get('api');
        let validPrefixes = [
            'http://' + api.host + '/',
            'https://' + api.host + '/',
        ]

        let contains = false;

        validPrefixes.forEach(element => {
            // Do we already have a match or do we check url again
            contains = contains ? contains : (url.indexOf(element) == 0);
        });

        return contains;
    }

    private isThirdParty(url) {
        return !this.isFirstParty(url);
    }


    headers(request: HttpRequest<any>, tokens?) {
        let headers = request.headers;

        if (!request.url.includes('/profile-image') &&
            !request.url.includes('/image') &&
            !request.url.includes('broadcasting/auth')
        ) {
            headers = headers.append('Content-Type', 'application/json');
            headers = headers.append('Accept', 'application/json');
        }

        headers = headers.append('Shard', this.shardHandler.getAlias());

        if (tokens != null) {
            let bearer = 'Bearer ' + tokens['access_token'];
            headers = headers.append('Authorization', bearer.trim());
        }

        return headers;
    }

    refreshToken(req: HttpRequest<any>, next: HttpHandler) {

        let authprov = this.inj.get(AuthenticationService);

        // If Authentication provider is refreshing queue up all calls
        if (!authprov.isRefreshing()) {
            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);

            return from(this.tokens.get().then(tokens => {
                    if (tokens != null) {
                        return authprov.refresh(tokens['refresh_token']).then(() => {
                            return this.tokens.get();
                        })
                    } else {
                        return null;
                    }

                })
            ).pipe(switchMap((tokens) => {
                    this.tokenSubject.next(tokens);
                    let newReq = req.clone({headers: this.headers(req, tokens)});
                    return next.handle(newReq);
                }),
                catchError(error => {
                    // If there is an exception calling 'refreshToken', bad news so logout.
                    return this.logoutUser();
                }))

        } else {
            return this.tokenSubject.pipe(filter(tokens => tokens != null)).pipe(take(1)).pipe(switchMap(tokens => {
                let newReq = req.clone({headers: this.headers(req, tokens)});
                return next.handle(newReq);
            }))
        }
    }

    logoutUser() {
        if (this.error != null) {
            return observableThrowError(this.error);
        }

        return observableThrowError('');
    }


}